import DataCoverage from "./DataCoverage";

export default DataCoverage;
